<app-button
  [disabled]="disabled"
  [fill]="fill()"
  [loading]="loading()"
  type="submit"
>
  <ng-content />
</app-button>
